
<mat-form-field [appearance]="appearanceSet" fxFlex="100%">
  <mat-label>{{placeholder}}{{required ? "*" : ""}}</mat-label>
  <input autocomplete="off" [formControl]="autoCompleteControl" type="text" [placeholder]="placeholderSet"
         aria-label="Number" matInput  [required]="required" [matAutocomplete]="auto" class="p-12">
  <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayColab">
    <mat-option *ngFor="let item of collaboratorAutoComplete$ | async; let index = index" [value]="item">

      <ng-container *ngIf="endpoint == suggestType.userSuggest">
        {{ item.description | titlecase}}</ng-container>

      <ng-container *ngIf="endpoint == suggestType.assignTeamSuggest">
        <div fxFlex="100%" fxLayout="row" fxLayoutAlign="space-between center">
          <span class="text-truncate">{{ item.description | titlecase}}</span>
          <span class="ml-8 font-size-14 item-type" fxHide.lt-sm>
            {{ 'COLAB-SUGGEST.TYPE.' + (item.type | titlecase) | translate}}</span>
        </div>
      </ng-container>
    </mat-option>
  </mat-autocomplete>
  <!-- <mat-error *ngIf="autoCompleteControl.hasError('incorrect') && !autoCompleteControl.hasError('required')">
    {{'COLAB-SUGGEST.SELECT-FROM-LIST' | translate}}
  </mat-error>
  <mat-error *ngIf="autoCompleteControl.hasError('required')">
    {{'COLAB-SUGGEST.SELECT-FROM-LIST' | translate}}
   {{'COLAB-SUGGEST.COLAB-REQ' | translate}} {{placeholderSet}} {{'COLAB-SUGGEST.COLAB-REQ-2' | translate}}!
  </mat-error> -->
  <!--  <mat-hint class="error" *ngIf="colabControlFormError">{{'COLAB-SUGGEST.COLAB-REQ' | translate}} {{placeholderSet}} {{'COLAB-SUGGEST.COLAB-REQ-2' | translate}}!</mat-hint>-->
  <!-- <button *ngIf="selectedItem" matSuffix  aria-label="Clear" (click)="reset()">
      <mat-icon>close</mat-icon>
  </button> -->
</mat-form-field>
